import React, { useState } from "react";
import styles from "../../assets/scss/Billing/AddBilling.module.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSearchParams } from "react-router-dom";
import { useCreateLedgerEntryMutation } from "../../slices/admin/admin";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";

const AddLedgerEntry = ({ onClose }) => {
  const [paymentType, setPaymentType] = useState("");
  const [amount, setAmount] = useState("");
  const [errors, setErrors] = useState({});
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const [createLedgerEntry, { isLoading }] = useCreateLedgerEntryMutation();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("id");

  const validate = () => {
    const newErrors = {};
    if (!paymentType) newErrors.paymentType = "Payment type is required";
    if (!amount) newErrors.amount = "Amount is required";
    else if (amount <= 0) newErrors.amount = "Enter valid amount";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    setConfirmModalOpen(true); // open confirmation modal
  };

  const handleSaveConfirm = async () => {
    setConfirmModalOpen(false);

    if (!customerId) {
      toast.error("Customer ID not found in URL");
      return;
    }

    try {
      await createLedgerEntry({
        customerId,
        paymentMethod: paymentType,
        paidAmount: Number(amount),
      }).unwrap();

      toast.success("Ledger created successfully!");
      onClose();
    } catch (err) {
      const errorMsg =
        err?.data?.message || err?.error || "Failed to create ledger entry";
      toast.error(errorMsg);
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Add Sales Ledger Entry</h2>
        <span className={styles.closeIcon} onClick={onClose}>
          ✕
        </span>
      </div>

      <div className={styles.AddLedgerEntryformSection}>
        {/* Payment Type */}
        <div className={styles.ownerinput}>
          <div className={styles.final}>
            <label className={styles.inputLabelssss}>Payment Type</label>
          </div>
          <select
            className={styles.inputsheader}
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
          >
            <option value="">Select</option>
            <option value="cash">Cash</option>
            <option value="upi">UPI</option>
            <option value="bank">Bank Account</option>
          </select>
          {errors.paymentType && (
            <p className={styles.errorText}>{errors.paymentType}</p>
          )}
        </div>

        {/* Amount */}
        <div className={styles.ownerinput}>
          <div className={styles.final}>
            <label className={styles.inputLabelssss}>Enter Amount</label>
          </div>
          <input
            className={styles.inputlastone}
            type="number"
            placeholder="Enter Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          {errors.amount && (
            <p className={styles.errorText}>{errors.amount}</p>
          )}
        </div>
      </div>

      <div className={styles.ownerinputs}>
        <button className={styles.cancelBtnlast} onClick={onClose}>
          Cancel
        </button>
        <button
          className={styles.saveBtnlast}
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Debit Amount"}
        </button>
      </div>

      {/* Confirmation Modal */}
      <DeleteConfirmModalLogout
        isOpen={confirmModalOpen}
        onConfirm={handleSaveConfirm}
        onCancel={() => setConfirmModalOpen(false)}
        title="Are you sure?"
        heading="Confirm Sales Debit Entry"
        content="Once saved, this Debit entry cannot be modified. Do you want to continue?"
      />
    </div>
  );
};

export default AddLedgerEntry;

